import Wrapper from "./Wrapper";
import Members from "./Members";
import Annotations from "./Annotations";
import Details from "./Details";

export default { Wrapper, Members, Annotations, Details };
